import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { ProfileApiService } from '../apiCalls/profile-api.service';
import { RoutesConst } from '../shared/route-const';

export interface CompanyProfile {
  Address: string;
  CompanyName: string;
  Country: string;
  PhoneNumber: string;
  ZipCity: string;
}

@Component({
  selector: 'app-company-profile',
  imports: [MatButtonModule, RouterLink, RouterOutlet],
  templateUrl: './company-profile.component.html',
  styleUrl: './company-profile.component.scss',
})
export class CompanyProfileComponent {
  routesConst = RoutesConst;

  private route = inject(ActivatedRoute);
  private readonly profileApiSvc = inject(ProfileApiService);
  companyInfo = this.profileApiSvc.getCompanyProfile();

  showMainRoute = signal(true);

  onActivate(): void {
    const path = this.route.snapshot.firstChild?.routeConfig?.path;
    switch (path) {
      case RoutesConst.edit:
        this.showMainRoute.set(false);
        break;
      default:
        this.showMainRoute.set(true);
    }
  }
  // Refresh the Fund Detail after Add or Edit
  onDeactivate() {
    this.showMainRoute.set(true);
  }
}
